import { computed, ref, watch } from 'vue';
import log from "../../services/Logger";
/**
 * The parts shared by all field controls: reactive field options and the
 * change, focus and blur events.
 */
export function useFieldControl(props, emit, name) {
    const fieldOptions = computed(() => props.field.options || {});
    function emitChange(value) {
        log(name + '@change', props.field.name, value);
        emit('change', value);
    }
    function onFocus() {
        emit('focus');
    }
    function onBlur() {
        emit('blur');
    }
    return { fieldOptions, emitChange, onFocus, onBlur };
}
/**
 * The local model of a control, (re)created from the field data whenever the data
 * changes from the outside.
 */
export function useFieldModel(toModel) {
    const model = ref(toModel());
    watch(toModel, value => model.value = value);
    return model;
}
